export default __webpack_public_path__ + "static/media/DF_Characters_Floris1.f4d90599.png";